import * as types from './types'
import moment from 'moment'
import storage from '@/Plugins/storage'

export default {
  [types.SET_PAGER](state, data) {
    switch (data.name) {
      case 'orderBy': {
        state.pager.orderBy = data.value
        break
      }
      case 'sortBy': {
        state.pager.sortBy = data.value
        break
      }
      case 'search': {
        state.pager.search = data.value
        break
      }
      case 'page': {
        state.pager.page = data.value
        break
      }
      case 'pageSize': {
        state.pager.pageSize = data.value
        break
      }
    }
    storage.session.setItem(types.STORE_PAGER, JSON.stringify(state.pager))
  },
  [types.SET_MEASUREMENTS](state, data) {
    state.measurements = []
    if (data !== undefined && data !== null) {
      state.measurements = data.data
      state.pager.page = data.current_page
      state.pager.pages = data.last_page
      state.pager.total = data.total
    }
    console.log('Got Measurements', state.measurements)
  },
  [types.SET_INITIAL_MEASUREMENT](state, data) {
    if (state.measurements) {
      state.measurements.forEach((element) => {
        element.IsInitial = null
        if (parseInt(element.id) === parseInt(data.id)) {
          element.IsInitial = 1
        }
      })
    }
  },
  [types.RESET_BODYCOMPOSITION](state, data) {
    state.bodycomposition = JSON.parse(
      JSON.stringify(state.defaultBodyComposition)
    )
    state.bodycomposition.user_id = data.userid
    state.bodycomposition.organization_id = data.orgid
  },
  [types.SET_BODYCOMPOSITION](state, data) {
    state.bodycomposition = null
    if (data !== undefined && data !== null) {
      state.bodycomposition = data
    }
    console.log('Got Body Composition', state.bodycomposition)
  },
  [types.SET_BODYCHARTS](state, data) {
    if (data !== undefined && data !== null) {
      state.bodycomposition.plotdatabodyweight = data.plotdatabodyweight
      state.bodycomposition.plotdatabodyfat = data.plotdatabodyfat
    }
  },
  [types.SET_BODYWEIGHTCHART](state, data) {
    if (data !== undefined && data !== null) {
      state.bodycomposition.plotdatabodyweight = data.plotdatabodyweight
    }
  },
  [types.SET_BODYFATCHART](state, data) {
    if (data !== undefined && data !== null) {
      state.bodycomposition.plotdatabodyfat = data.plotdatabodyfat
    }
  },
  [types.SET_TARGETS](state, data) {
    // console.log('Updating Targets after Save', data)
    state.bodycomposition.targetLastSetDays = 'Target Set: Today'
    state.bodycomposition.targetLastSet = moment().format('MM/DD')
    state.bodycomposition.targetBodyWeight = data.TargetBodyWeight
    state.bodycomposition.targetBodyFat = data.TargetBodyFat
  },
}
